module.exports = __webpack_public_path__ + "img/diamond.0f5345a8.png";